import React from 'react';
// import './Features.css';

const Features = () => {
  return (
    <div className="features-page">
      <h1>Features</h1>
      <ul>
        <li>
          <h3>Easy Search</h3>
          <p>Our search function is quick and easy to use. Simply type in the name of the movie or series you're looking for and we'll do the rest. No more scrolling through endless lists – our search function will give you the results you're looking for in seconds.</p>
        </li>
        <li>
          <h3>Detailed Information</h3>
          <p>We provide detailed information about each movie and series, including cast, ratings, IMDb score, and more. This makes it easy for you to make informed decisions about what to watch and ensures that you never miss a detail about your favorite movies and series.</p>
        </li>
        <li>
          <h3>Community</h3>
          <p>We believe that Entertainment-hub is more than just a movie and series database. It's a community where movie and series fans can come together to share their love for the latest and greatest in the entertainment world. Whether you're a casual movie-goer or a die-hard fan, Entertainment-hub is the perfect place for you to connect with others who share your passion.</p>
        </li>
      </ul>
    </div>
  );
};

export default Features;
